import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalProgramStore from '../../../../../../stores/program-store';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const linkCoursesToCurrentProgramOperation = async (
  branchId: number,
  sourceProgramId: number,
  targetProgramId: number,
  year: number,
  courseIds: number[],
  setLoading: (loading: boolean) => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const sources = courseIds.map((courseId) => ({
      programId: sourceProgramId,
      courseId,
    }));

    const res = await appApi.linkCoursesToProgram(
      branchId,
      targetProgramId,
      year,
      sources,
    );

    if (!res.data.ok) {
      if (res.data.errCode) {
        toast.warn(displayErrorText(res.data.errCode));
      } else {
        toast.error('ייבוא הקורסים נכשל, נסה שוב');
      }
      setLoading(false);
      return false;
    }

    globalProgramStore.updateProgramDetails(targetProgramId, res.data.body);
    setLoading(false);
    return true;
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    return false;
  }
};
